import Vue from 'vue';

import L10n from './l10n/l10n';
import ResizeObserver from './resize-observer/resize-observer.vue';
import Scrollable from './scrollable/scrollable.vue';

Vue.component('l10n', L10n as any);
Vue.component('resize-observer', ResizeObserver);
Vue.component('scrollable', Scrollable);
